import { useUserHomeRoute } from '@platform-ui/utilities/Routes.js';
import { Navigate } from 'react-router-dom-v5-compat';

export default function UserHomeRedirect(): JSX.Element {
  const userHome = useUserHomeRoute();
  return <Navigate to={userHome} replace />;
}
